import { getDialogHooks } from 'utilities/dialog-context/DialogContextHelpers';
import {
  ChangeLogDialog,
  ChangeLogDialogCallbackInput,
  ChangeLogDialogUniqueProps,
} from '../ChangeLogDialog';

const { useDialogForContext, useDialog: useChangeLogDialog } = getDialogHooks<
  ChangeLogDialogUniqueProps,
  ChangeLogDialogCallbackInput
>(ChangeLogDialog);
export const useChangeLogDialogForContext = useDialogForContext;
export default useChangeLogDialog;
